import { OnboardingRepo } from "../onboarding.repo";
import * as _ from "lodash";
import { FileItems } from "../FileItems";

class clientInfoController implements angular.IOnInit {
  public selectedClient: string;
  public isLoading = false;
  public files: FileItems[];
  public status: string;

  /** @ngInject */
  constructor(
    private onboardingRepo: OnboardingRepo,
    private $state: angular.ui.IStateService,
    private $stateParams: angular.ui.IStateParamsService,
    private notifyjs: any,
    private $window: angular.IWindowService,
    private $mdDialog: angular.material.IDialogService
  ) {}

  $onInit() {
    this.isLoading = true;
    this.loadClientData();
  }

  loadClientData() {
    this.files = [];
    this.onboardingRepo
      .getClientFiles(this.selectedClient)
      .then((files) => {
        this.files = files;
        this.isLoading = false;
      })
      .catch((err) => {
        this.notifyjs(`Failed to retrieve file: ${err}`);
        this.isLoading = false;
      });
  }

  //TODO: Implement cancel/back button
  cancelFileEdit() {
    this.selectedClient = undefined;
    this.$state.go("root.clientapplication");
  }

  getFileName(file) {
    return file.key.split(`clients/${this.selectedClient}/`)[1];
  }

  downloadFileUrl(file) {
    this.$window.open(file.url, "_blank");
  }

  close() {
    this.$mdDialog.hide(true);
  }

  sendClientUpdate() {
    this.isLoading = true;
    this.onboardingRepo
      .sendStatusUpdate(this.selectedClient, this.status)
      .then((res) => {
        this.isLoading = false;
        this.notifyjs(`Status update has been sent.`);
      })
      .catch((err) => this.notifyjs(`Failed to send status update: ${err}`));
  }

  deleteFile(file) {
    this.isLoading = true;
    this.onboardingRepo.deleteFile(file.key).then(() => {
      this.loadClientData();
    });
  }
}

export const clientInfo: angular.IComponentOptions = {
  template: require("./clientInfo.modal.html"),
  controller: clientInfoController,
  bindings: {
    selectedClient: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/onboarding/viewClient/clientInfo.modal.ts